<template>
  <div data-module="contact-header">
    <div class="component-layout">
      <div class="background" id="video"
        v-if="type === 'video'"
      >
        <video autoplay muted loop playsinline
          :poster="bgData.poster"
        >
          <source :src="bgData.src" />
          <img
            :alt="bgData.alt"
            :src="bgData.poster"
          >
        </video>
      </div>
      <h1 v-html="headline" />
    </div>
  </div>
</template>

<script>
/*
  currently only coded to show a video
  original code was able to display more more

  current data structure:

    {
    headline: string // 'Welcome<br />to Particle.',
    background: {
      type: string // 'video'
      data: {
        src: string
        poster: string
        alt: string
      }
    },
  },

*/
export default {
  name: 'contact-header',

  props: ['data'],

  computed: {

    headline() {
      const { headline } = this.data;
      return headline;
    },

    background() {
      const { background } = this.data;
      return background;
    },

    type() {
      const { background } = this;
      const { type } = background;
      return type;
    },

    bgData() {
      const { background } = this;
      const { data } = background;
      return data;
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~@/styles/_grid.scss';
@import '~@/styles/_mixins.scss';
@import '~@/styles/_typography.scss';
@import '~@/styles/_variables.scss';

[data-module="contact-header"] {
  width: 100%;

  // media query props
  margin-top: rem($height--nav-bar-mobile * 1px); // adjust for nav bar
  margin-bottom: rem($layout--default-module-spacing-mobile);

  @include ngMq($nbp--tablet, up) {
    margin-top: rem($height--nav-bar-tablet * 1px);
    margin-bottom: rem($layout--default-module-spacing-tablet);
  }

  @include ngMq($nbp--desktop, up) {
    margin-top: rem($height--nav-bar-desktop * 1px);
    margin-bottom: rem(50px);
  }

  .component-layout {
    // media query props
    @include ngGrid('mobile');
    margin: 0px;

    @include ngMq($nbp--tablet, up) {
      @include ngGrid('tablet');
    }

    @include ngMq($nbp--desktop, up) {
      @include ngGrid('desktop');
    }

    .background {
      overflow: hidden;
      grid-column: 1 / -1;

      // media query props
      padding-bottom: $dimension-16-9;
      margin: 0 rem($grid-padding-mobile * -1px); // pull to columns
      margin-top: rem(96px);

      @include ngMq($nbp--tablet, up) {
        padding-bottom: $dimension-21-9;
        margin: 0;
        margin-top: rem(134px);
      }

      @include ngMq($nbp--desktop, up) {
        padding-bottom: $dimension-21-9;
        margin: 0;
        margin-top: rem(146px);
      }

      &[id="image"] {
        background-size: cover;
        background-position: center center;
        background-repeat: no-repeat;
      }

      video {
        position: absolute;
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
    }

    h1 {
      position: absolute;
      top: 0;

      // media query props
      @include serif( $size: (50, 39, 0), $weight: 'bold');
      grid-column: 1 / -1;
      margin-top: rem(36px);
      margin-left: 0;

      @include ngMq($nbp--tablet, up) {
        @include serif( $size: (60, 55, -0.14), $weight: 'bold');
        grid-column: 2 / -1;
        margin-top: rem(50px);
        margin-left: rem($grid-gap-tablet * -1px); // pull to left, grid gap
      }

      @include ngMq($nbp--desktop, up) {
        @include serif( $size: (90, 85, -0.2), $weight: 'bold');
        grid-column: 2 / -1;
        margin-top: rem(18px);
        margin-left: rem($grid-gap-desktop * -1px); // pull to left, grid gap
      }
    }

  }

}
</style>



// WEBPACK FOOTER //
// src/modules/contact/ContactHeader.vue